import { render, staticRenderFns } from "./FiveDayOrders.vue?vue&type=template&id=18821fde&scoped=true"
import script from "./FiveDayOrders.vue?vue&type=script&lang=js"
export * from "./FiveDayOrders.vue?vue&type=script&lang=js"
import style0 from "./FiveDayOrders.vue?vue&type=style&index=0&id=18821fde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18821fde",
  null
  
)

export default component.exports